import axios from 'axios';

export const submitOrganizerApplication = (data) =>
  axios.post('/organizer-applications', data);
